import React from "react";

export const PageLayout: React.FC = (props) => {
  return <div style={{ padding: "0 1rem 1rem" }}>{props.children}</div>;
};

export default PageLayout;
